// extracted by mini-css-extract-plugin
var _1 = "#007ac9";
var _2 = "#575757";
var _3 = "1.5rem";
var _4 = "#dedede";
var _5 = "#adf";
var _6 = "1rem";
var _7 = "#bebebe";
var _8 = "popupContainer-atSQ";
var _9 = "popupOption-SwMQ";
var _a = ".8rem";
var _b = "#000";
export { _1 as "busBlue", _2 as "darkGrey", _3 as "extraLargeFontSize", _4 as "lightGrey", _5 as "lightblue", _6 as "mediumFontSize", _7 as "mediumLightGrey", _8 as "popupContainer", _9 as "popupOption", _a as "smallFontSize", _b as "unusedNodeColor" }
